<div class="flex flex-col justify-between">
  <table class="no-space w-full" cellspacing="0" cellpadding="4">
    @if (timeSheet.currentEquipmentCrew.length > 0) {
      <tr class="h-[50px]">
        <th>
          <a mat-raised-button routerLink="/crew/equipment">
            <mat-icon>local_shipping</mat-icon>
            Add Equipment
          </a>
        </th>
        <th><button mat-raised-button aria-label="Bulk Add Hours" (click)="bulkEntry()">Hours</button></th>
        <th>Daily Total</th>
        <th>Weekly Total</th>
      </tr>
    }
    @for (row of timeSheet.currentEquipmentCrew; track row) {
      <tr>
        <td>
          <read-only-text
            [val]="row.display"
            [shouldShowDelete]="true"
            (deleteClicked)="row.deleteSelf(timeSheet.currentEquipmentCrew)"
          />
        </td>
        <td>
          <numeric-input-field [max]="24" [control]="row.value" />
        </td>
        <td class="align-top">
          <read-only-field [val]="row.workDateTotal | number" />
        </td>
        <td class="align-top">
          <read-only-field [val]="row.weDateTotal | number" />
        </td>
      </tr>
    }
    @if (shouldShowEquipmentSkf) {
      @for (row of timeSheet.currentEquipmentProduction; track row) {
        <tr>
          <td>
            <read-only-text
              [shouldTranslate]="true"
              [val]="row.display"
              [shouldShowDelete]="true"
              (deleteClicked)="handleEquipmentDelete(row)"
            />
          </td>
          <td>
            <numeric-input-field [control]="row.value" />
          </td>
          <td>
            <read-only-field [val]="row.workDateTotal | number" />
          </td>
          <td></td>
        </tr>
      }
    }
    @if (timeSheet.currentEquipmentCrew.length === 0) {
      <tr class="h-[500px]">
        <th>
          <div>
            <a mat-raised-button routerLink="/crew/equipment">Start Here</a>
          </div>
        </th>
      </tr>
    }
  </table>
  @if (shouldShowEquipmentSkf) {
    <div class="skf-container mb-2 flex gap-12">
      @for (button of equipmentProductionButtons; track button) {
        <button mat-raised-button notranslate (click)="addEquipment(button)">+ {{ button.CustDesc }}</button>
      }
    </div>
  }
</div>
